<div>
    <ng-template briksHost></ng-template>
    <!-- <nackle-quiz-questionnaire [promotionId]="promotionId" [enableContent]="enableContent" *ngIf="promotionId" [isAdmin] = "isAdmin" 
                [culture] = "selectedCulture" [userTimeZone] = "userTimeZone"></nackle-quiz-questionnaire> -->
</div>